async function getLockedData() {
  const lockedUrl = new URL(window.location.href);
  lockedUrl.searchParams.set('view', 'locked');

  const response = await fetch(lockedUrl.toString(), {
    credentials: 'same-origin',
    headers: {
      Accept: 'text/html'
    }
  });

  if (!response.ok) {
    throw new Error(`Unable to fetch locked view: ${response.status}`);
  }

  const html = await response.text();
  const doc = new DOMParser().parseFromString(html, 'text/html');
  const dataScript = doc.querySelector('script[id^="LockedData-"]');

  if (!dataScript) {
    throw new Error('Locked data script was not found.');
  }

  return JSON.parse(dataScript.textContent);
}

function waitForElement(selector, timeout = 5000) {
  const existingElement = document.querySelector(selector);

  if (existingElement) {
    return Promise.resolve(existingElement);
  }

  return new Promise((resolve, reject) => {
    const observer = new MutationObserver(() => {
      const element = document.querySelector(selector);

      if (!element) {
        return;
      }

      clearTimeout(timeoutId);
      observer.disconnect();
      resolve(element);
    });

    const timeoutId = window.setTimeout(() => {
      observer.disconnect();
      reject(new Error(`${selector} was not found.`));
    }, timeout);

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  });
}

function addLockedTitle(data) {
  const lockedText = data?.settings?.locked_text;
  const lockedPrePostText = data?.settings?.locked_pre_post_text;
  const lockedPostText = data?.settings?.locked_post_text;
  const passcodeForm = document.querySelector('#locksmith_passcode_form');
  const preText = document.querySelector('.locksmith-form__pre');
  const prePostText = document.querySelector('.locksmith-form__pre-post');
  const postText = document.querySelector('.locksmith-form__post');

  if ((!lockedText && !lockedPrePostText && !lockedPostText) || !passcodeForm) {
    return;
  }

  if (lockedText && preText) {
    preText.innerHTML = lockedText;
  }

  if (lockedPrePostText && prePostText) {
    prePostText.innerHTML = lockedPrePostText;
  }

  if (lockedPostText && postText) {
    postText.innerHTML = lockedPostText;
  }
}

function setLockedBackground(data) {
  const background = data?.settings?.background;
  const locksmithContent = document.querySelector('#locksmith-content');

  if (!background || !locksmithContent) {
    return;
  }

  locksmithContent.style.setProperty('--bg', `url("${background}")`);
}

function addLockedImage(data) {
  const image = data?.settings?.image;
  const title = data?.settings?.title;
  const imageElement = document.querySelector('.locksmith-passcode__image img');

  if (!image || !imageElement) {
    return;
  }

  imageElement.src = image;
  imageElement.alt = title || '';
  imageElement.decoding = 'async';
}

Promise.all([
  getLockedData(),
  waitForElement('#locksmith_passcode_form')
])
  .then(([data]) => {
    setLockedBackground(data);
    addLockedImage(data);
    addLockedTitle(data);
  })
  .catch((error) => {
    console.error(error);
  });
